import React, { useState } from 'react'
import Text from '../../components/Text'
import FaqContainer from '../../components/FaqContainer'
import FaqGroup from '../../models/WebContent'
import { Fetch } from '@polvo-labs/react-auth'
import Loader from '../../components/Loader'

interface Props {

}

const FaqScreen: React.FC<Props> = () => {
  const [apiUrl] = useState(`${process.env.REACT_APP_API_URL}/faqs`)

  return (
    <div>
      <Text
        tag='h1'
        color="darkGray"
      >
        Perguntas Frequentes
      </Text>
      <Fetch
        url={apiUrl}
        loader={() => (
          <Loader
            darkMode
          />
        )}
      >
        {({ data }) => data && data.data ? (
          <>
            <FaqContainer 
              faqs={data.data as FaqGroup[]}
            />
          </>
        ) : (
          <span>
            Error
          </span>
        )}
      </Fetch>
    </div>     
  )
}

export default FaqScreen
